import React, { useContext, useEffect, useState } from "react";
import { FaFileAlt, FaTimes } from "react-icons/fa";
import { IoIosAddCircleOutline } from "react-icons/io";
import { useNavigate, useLocation } from "react-router-dom";
import ThemeContext from "../../../../Context/theme/ThemeContext";

const OfferDetail = () => {
  const { theme } = useContext(ThemeContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [OfferDetailsData, setOfferDetailsData] = useState({
    Type: "",
    Title: "",
    Price: "",
    Delivery: "",
    Description: "",
    Buyers: [""],
    files: [],
  });
  const [errors, setErrors] = useState({});

  //validation  functions
  const validateTitle = (title) => {
    if (!title.trim()) {
      return "Title is required";
    }
    if (title.length < 3) {
      return "Title must be at least 3 characters long";
    }
    if (title.length > 100) {
      return "Title must be less than 100 characters";
    }
    return "";
  };

  const validatePrice = (price) => {
    if (!price) {
      return "Price is required";
    }
    if (isNaN(price) || Number(price) <= 0) {
      return "Price must be greater than 0";
    }
    if (Number(price) > 1000000) {
      return "Price cannot exceed 1,000,000";
    }
    return "";
  };

  const validateDelivery = (delivery) => {
    if (!delivery) {
      return "Delivery date is required";
    }
    const selectedDate = new Date(delivery);
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (selectedDate < today) {
      return "Delivery date cannot be in the past";
    }
    return "";
  };

  const validateDescription = (description) => {
    if (!description.trim()) {
      return "Description is required";
    }
    if (description.length < 20) {
      return "Description must be at least 20 characters long";
    }
    if (description.length > 1000) {
      return "Description must be less than 1000 characters";
    }
    return "";
  };

  const validateFiles = (files) => {
    // if (!files.length) {
    //   return "At least one file is required";
    // }

    const maxSize = 5 * 1024 * 1024; // 5MB
    const allowedTypes = [
      "video/mp4",
      "video/mov",
      "audio/mp3",
      "audio/wav",
      "image/jpeg",
      "image/png",
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ];

    for (let file of files) {
      if (file.size > maxSize) {
        return "Each file must be less than 5MB";
      }
      if (!allowedTypes.includes(file.type)) {
        return "Only JPG, MP4, MOV, AVI, MP3, WAV, PNG, PDF and DOC files are allowed";
      }
    }
    return "";
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setOfferDetailsData((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleFileUpload = (e) => {
    const files = Array.from(e.target.files);
    const fileError = validateFiles(files);

    if (fileError) {
      setErrors((prev) => ({
        ...prev,
        files: fileError,
      }));
      return;
    }

    setOfferDetailsData((prevDetails) => ({
      ...prevDetails,
      files: [...prevDetails.files, ...files],
    }));
    setErrors((prev) => ({
      ...prev,
      files: "",
    }));
  };

  useEffect(() => {
    const { OfferDetails } = location.state || {};
    if (OfferDetails) {
      setOfferDetailsData((prev) => ({
        ...prev,
        Type: OfferDetails,
      }));
    }
  }, [location.state]);

  const validate = () => {
    const newErrors = {
      Type: !OfferDetailsData.Type ? "Offer type is required" : "",
      Title: validateTitle(OfferDetailsData.Title),
      Price: validatePrice(OfferDetailsData.Price),
      Delivery: validateDelivery(OfferDetailsData.Delivery),
      Description: validateDescription(OfferDetailsData.Description),
    };

    setErrors(newErrors);
    return !Object.values(newErrors).some((error) => error !== "");
  };

  const handleSubmit = () => {
    if (validate()) {
      navigate("/user-dashboard/offer_user", {
        state: { OfferDetailsData: OfferDetailsData },
      });
    }
  };

  const removeFile = (index) => {
    setOfferDetailsData((prev) => ({
      ...prev,
      files: prev.files.filter((_, i) => i !== index),
    }));
  };

  return (
    <div className="flex items-center font-pop flex-col">
      <div
        className={`rounded-2xl py-6 px-6 my-6 w-[95%] md:w-[70%] xl:w-[45%] flex flex-col gap-4
             ${theme === "dark" ? "bg-black text-white" : "bg-white"}`}
      >
        <h1
          className={`font-semibold text-2xl ${
            theme === "dark" && "text-white"
          } `}
        >
          Create Offer
        </h1>
        <p
          className={` text-lightGrey font-pop  ${
            theme === "dark" && "text-white"
          }`}
        >
          {OfferDetailsData?.Type || "Offer Type"}
        </p>

        <div className="flex flex-col gap-4">
          <input
            type="text"
            id="title"
            name="Title"
            placeholder="Offer title"
            value={OfferDetailsData?.Title || ""}
            onChange={handleChange}
            className={`w-full px-6 truncate border-2 ${
              errors.Title ? "border-red-500" : "border-transparent"
            } font-pop text-base rounded-full  ${
              theme === "dark"
                ? "bg-black text-white  border border-white"
                : "bg-white"
            } bg-[#E8E8E8] py-2 focus:border-primarygreen focus:outline-none`}
          />
          {errors.Title && (
            <p className="text-red-500 text-sm">{errors.Title}</p>
          )}
          <div className="flex flex-col md:flex-row gap-2">
            <div className="flex-1">
              <input
                type="number"
                id="price"
                name="Price"
                min={1}
                placeholder="Price"
                value={OfferDetailsData?.Price || ""}
                onChange={handleChange}
                className={`w-full px-6 border-2 ${
                  errors.Price ? "border-red-500" : "border-transparent"
                } font-pop text-base rounded-full  ${
                  theme === "dark"
                    ? "bg-black text-white border border-white"
                    : "bg-white"
                } bg-[#E8E8E8] py-2 focus:border-primarygreen focus:outline-none`}
              />
              {errors.Price && (
                <p className="text-red-500 text-sm">{errors.Price}</p>
              )}
            </div>
            <div className="flex-1">
              <input
                type="date"
                id="delivery"
                name="Delivery"
                placeholder="Delivery"
                value={OfferDetailsData?.Delivery || ""}
                onChange={handleChange}
                className={`w-full px-6 border-2 ${
                  errors.Delivery ? "border-red-500" : "border-transparent"
                } font-pop text-base rounded-full  ${
                  theme === "dark"
                    ? "bg-black text-white   border border-white"
                    : "bg-white"
                } bg-[#E8E8E8] py-2 focus:border-primarygreen focus:outline-none`}
              />
              {errors.Delivery && (
                <p className="text-red-500 text-sm">{errors.Delivery}</p>
              )}
            </div>
          </div>

          <textarea
            name="Description"
            placeholder="What are you looking to get done?"
            value={OfferDetailsData?.Description || ""}
            onChange={handleChange}
            cols="30"
            rows="4"
            className={`w-full px-6 border-2 ${
              errors.Description ? "border-red-500" : "border-transparent"
            } font-pop text-base rounded-2xl  ${
              theme === "dark"
                ? "bg-black text-white  border border-white"
                : "bg-white"
            }  bg-[#E8E8E8] py-2 focus:border-primarygreen focus:outline-none`}
          />
          {errors.Description && (
            <p className="text-red-500 text-sm">{errors.Description}</p>
          )}
          <div
            className={`flex items-center justify-center w-full  ${
              theme === "dark" ? "bg-black text-white" : "bg-white"
            }`}
          >
            <label
              htmlFor="dropzone-file"
              className={`flex flex-col items-center justify-center w-full border-2 ${
                errors.files ? "border-red-500" : "border-primarygreen"
              } border-dashed rounded-lg  ${
                theme === "dark"
                  ? "bg-black text-white  border border-white"
                  : "bg-white"
              } cursor-pointer `}
            >
              <div
                className={`flex flex-row gap-4 items-center justify-center py-3 text-primarygreen font-pop  
              `}
              >
                <IoIosAddCircleOutline className="text-2xl" />
                <p
                  className={`text-base    ${
                    theme === "dark" && " text-white  "
                  }`}
                >
                  Attach file
                </p>
              </div>
              <input
                id="dropzone-file"
                type="file"
                multiple
                onChange={handleFileUpload}
                className="hidden"
              />
            </label>
          </div>
          {/* {errors.files && (
            <p className="text-red-500 text-sm">{errors.files}</p>
          )} */}
          <div className="flex gap-2 flex-wrap">
            {OfferDetailsData?.files?.map((item, index) => (
              <div
                className="border-2 border-primarygreen truncate rounded-lg py-2 px-2 flex gap-1 items-center"
                key={index}
              >
                <FaFileAlt />
                <p className="max-w-[150px] truncate">{item?.name}</p>
                <FaTimes
                  className="cursor-pointer hover:text-red-500"
                  onClick={() => removeFile(index)}
                />
              </div>
            ))}
          </div>

          <button
            className={`my-4 px-2 md:px-6 bg-green-500 hover:bg-transparent hover:bg-white-500 font-medium hover:text-black font-pop text-sm md:text-lg py-2 md:py-3 border border-black-500 hover:border-green-500 rounded-full text-white    
 ${theme === "dark" ? "hover:text-white" : " hover:text-black"}`}
            onClick={handleSubmit}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default OfferDetail;
